import type { ReactNode } from "react";

// Shared prose elements for insight articles, styled to match the premium look.

export function H2({ children, id }: { children: ReactNode; id?: string }) {
  return (
    <h2 id={id} className="mt-12 scroll-mt-28 text-2xl font-extrabold text-foreground sm:text-3xl">
      {children}
    </h2>
  );
}

export function P({ children }: { children: ReactNode }) {
  return <p className="mt-4 text-base leading-relaxed text-muted-foreground">{children}</p>;
}

export const thClass =
  "px-4 py-3 text-start text-xs font-bold uppercase tracking-wider text-foreground";
export const tdClass = "px-4 py-3 text-start text-sm text-muted-foreground align-top";

/** Wraps a <table> in a scrollable, bordered container. */
export function TableWrap({ children }: { children: ReactNode }) {
  return (
    <div className="mt-6 overflow-x-auto rounded-2xl border border-border">
      <table className="w-full border-collapse">{children}</table>
    </div>
  );
}
